module.exports = __webpack_public_path__ + "static/media/hw_ra_39.6590713a.flv";